<template>
  <div style="width: 100; height: 100%;">
    <owal-banner :style="`border: 6px solid ${colorForAccessEvent(event.best_match_confidence)}; border-radius: 0.5rem;`">
      <div class="credential-realtime-view__banner-container">
        <base-detection
          :baseImageURL="imageForDetectionID(event.best_match_detection_id, true)"
          :imageTitle="`${event.lastSteen}\n${event.access_point_description}`"
          :showRemove="false"
          :selected="true"
          :baseDetectionStyle="`border: 6px solid ${colorForAccessEvent(event.best_match_confidence)};`"
          />
        <base-detection
          :baseImageURL="imageForCredentialUUID(event.credential_uuid, true)"
          :imageTitle="`${event.given_name} ${event.surname}`"
          :showRemove="false"
          />
        <div class="credential-realtime-view__detection-details">
          Timestamp: {{event.lastSteen}} <br/>
          Turnstile: {{event.access_point_description}} <br/>
          Match confidence: {{event.best_match_confidence && event.best_match_confidence.toFixed(3)}} <br/>
          Surname, Given Name: {{event.surname}}, {{event.given_name}} <br/>
          <!-- <div> -->
          <owal-button
            :title="'edit'"
            style="margin-top: 1.5rem;"
            @click="watchVideo()"
            >
            Video
            <div style="min-width: 3rem; display: flex; flex-direction: row; justify-content: center;">
              <font-awesome-icon
                slot="accessory"
                icon="video"
                />
            </div>
          </owal-button>
          <!-- </div> -->
        </div>
      </div>
    </owal-banner>
  </div>
</template>

<script>
import { imageForCredentialUUID, imageForDetectionID } from '@/libraries/api/faces'
import BaseDetection from '@/components/shared/BaseDetection'
import { OwalBanner, OwalButton } from '@/libraries/owal-ui/'
import { mapGetters } from 'vuex'

export default {
  name: 'RealtimeEventCard',
  props: ['event'],
  components: {
    OwalBanner,
    OwalButton,
    BaseDetection,
  },
  computed: {
    ...mapGetters({
      camerasForCurrentDomain: 'camerasForCurrentDomain',
    }),
  },
  methods: {
    imageForCredentialUUID,
    imageForDetectionID,
    colorForAccessEvent (confidence) {
      if (!confidence || confidence === 0) {
        return 'white'
      }
      if (confidence > 0.95) {
        return 'rgba(35, 136, 35, .5)'
      }
      if (confidence > 0.8) {
        return 'rgba(255, 191, 0, .5)'
      }
      return 'rgba(210, 34, 45, .5)'
    },
    watchVideo () {
      const path = {
        path: `/view/${this.event.camera_uuid}/${this.event.event_ts}`,
      }

      this.$router.push(path)
    },
  },
}
</script>

<style>
  .credential-realtime-view__banner-container {
    margin: 1rem;
    display: flex;
    flex-direction: row;
    width: 95%;
  }

  .credential-realtime-view__detection-details {
    margin-left: 1.5rem;
  }
</style>
